<template>
  <v-card color="grey lighten-5" flat>
    <v-layout row wrap>
      <v-flex xs12 md12 sm12>
        <v-toolbar size="120px" dark color="info">
          <v-toolbar-title>{{$t('Payment-List')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="odemeEkle()" flat><v-icon>add_box</v-icon> {{ $t('save_button') }}</v-btn>
        </v-toolbar>
      </v-flex>
      <v-flex xs12 md12 sm12>
        <pnrodeme ref="pnrOdeme" v-model="Odeme"></pnrodeme>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import pnrodeme from "../component/pnrodeme.vue";
export default {
  components: { pnrodeme },
  data() {
    return {
      Odeme: {
        OdemeTarihi: null,
        OdemeTipi: 0,
        NakitBilgi: {
          KarsiCari: {
            Unvan2: null,
            Adres1: null,
            Adres2: null,
            VergiDairesi: null,
            VergiNo: null,
            TCKimlikNo: null,
            Ilce_Il: null,
            EfaturaKayitli: null,
            PerFirstName: null,
            PerFamilyName: null,
            EMail: null,
          },
          KarsiCariAciklama: null,
        },
        KrediKartBilgi: {
          KarsiCari: {
            kod: null,
            Unvan2: null,
            Adres1: null,
            Adres2: null,
            VergiDairesi: null,
            VergiNo: null,
            TCKimlikNo: null,
            Ilce_Il: null,
            EfaturaKayitli: null,
            PerFirstName: null,
            PerFamilyName: null,
            EMail: null,
          },
          KarsiCariAciklama: null,
          FirmaKrediKartli: false,
          KartNo: null,
          KartAdi: null,
          KartTipi: null,
          Banka: null,
          Taksit: 0,
          PosKodu: null,
          PosTaksit: null,
          PuanTutari: 0,
        },
        HavaleBilgi: {
          Banka: null,
          Aciklama: null,
        },
        SanalPosBilgi: {
          KarsiCari: {
            Unvan2: null,
            Adres1: null,
            Adres2: null,
            VergiDairesi: null,
            VergiNo: null,
            TCKimlikNo: null,
            Ilce_Il: null,
            EfaturaKayitli: null,
            PerFirstName: null,
            PerFamilyName: null,
            EMail: null,
          },
          KarsiCariAciklama: null,
        },
        Tutar: 0,
        ParaBirimi: "TL",
        Kur: 1,
        OdemeIadesi: false,
        PNR_No: null,
        EvrakNo: null,
        Aciklama: null,
      },
    };
  },
  mounted() {
    // Sayfa açıldığında varsayılan para birimini Local Storage'dan uygula
    this.applyDefaultCurrencyFromStorage();
  },

  methods: {
    odemeEkle() {
      this.$refs.pnrOdeme.addOdeme();
    },
    applyDefaultCurrencyFromStorage() {
      try {
        let defaultCur = null;

        // 1) "response" anahtarındaki JSON'dan dene (ekrandaki görüntüdeki gibi)
        const rawResp = window.localStorage.getItem("response");
        if (rawResp) {
          const parsed = JSON.parse(rawResp);
          if (parsed && parsed.ParaBirimi) defaultCur = parsed.ParaBirimi;
        }

        // 2) Bulunamazsa "credentials" içinden dene
        if (!defaultCur) {
          const creds = window.localStorage.getItem("credentials");
          if (creds) {
            const c = JSON.parse(creds);
            defaultCur =
              (c && (c.ParaBirimi || (c.UserInfo && c.UserInfo.ParaBirimi))) ||
              null;
          }
        }

        // 3) Bulunduysa Odeme modeline uygula
        if (defaultCur) {
          this.Odeme.ParaBirimi = defaultCur;
          // Kur değerini burada sabitlemek istemiyorsan dokunma;
          // istersen TL değilse 1 bırak veya senin kur yükleme akışında set edilecektir.
        }
      } catch (e) {
        // sessiz geç
      }
    },
  },
  

};
</script>

<style>
</style>